import { connect } from '@atlassian/jira-react-redux';
import { openAvatarPickerDialog } from '../../../state/ui/actions';
import { isAvatarPickerEnabledSelector } from '../../../state/ui/selectors';
import AvatarImage from './avatar-image';
import Avatar from './view';

export default connect(
	(state) => ({
		AvatarImage,
		// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'AppState'.
		isEnabled: isAvatarPickerEnabledSelector(state),
	}),
	{
		onSelectAvatar: openAvatarPickerDialog,
	},
)(Avatar);
